export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20minimal%20abstract%20composition%20with%20soft%20cream%20beige%20and%20gentle%20terracotta%20gradients%2C%20flowing%20organic%20shapes%20reminiscent%20of%20fabric%20folds%2C%20subtle%20texture%2C%20light%20airy%20atmosphere%2C%20modern%20aesthetic%2C%20editorial%20quality%2C%20no%20text%20no%20products%2C%20warm%20inviting%20tone&width=1600&height=900&seq=hero-bg-vigorbuy-v2&orientation=landscape"
          alt="Vigorbuy Spreadsheet product discovery platform background"
          title="Vigorbuy Spreadsheet - Product Discovery Resource"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 leading-tight mb-5">
          Vigorbuy Spreadsheet — The Ultimate Product Finding Resource
        </h1>
        <p className="text-base md:text-lg text-background-50/90 max-w-2xl mx-auto mb-9 leading-relaxed">
          Discover the latest Vigorbuy Spreadsheet collections, verified product finds, QC photos, shopping guides, and expert tips to find better products faster.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-accent-500 text-background-50 px-8 py-3.5 rounded-md text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Vigorbuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-background-50 text-foreground-900 px-8 py-3.5 rounded-md text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 mt-8">
          <span className="flex items-center gap-1.5 text-xs text-background-50/80">
            <i className="ri-check-line text-accent-400"></i> Updated Regularly
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/80">
            <i className="ri-check-line text-accent-400"></i> Independent Resource
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/80">
            <i className="ri-check-line text-accent-400"></i> Beginner Friendly
          </span>
          <span className="flex items-center gap-1.5 text-xs text-background-50/80">
            <i className="ri-check-line text-accent-400"></i> Shopping Guide
          </span>
        </div>
      </div>
    </section>
  );
}